import { render, staticRenderFns } from "./KickCombos.vue?vue&type=template&id=b2055d10&scoped=true"
import script from "./KickCombos.vue?vue&type=script&lang=js"
export * from "./KickCombos.vue?vue&type=script&lang=js"
import style0 from "./KickCombos.vue?vue&type=style&index=0&id=b2055d10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2055d10",
  null
  
)

export default component.exports